



























































import Vue from 'vue';
import StepContent from '@/components/StepContent.vue';
import BackgroundTools from '@/components/BackgroundTools.vue';

export default Vue.extend<any, any, any, any>({
	components: { BackgroundTools, StepContent },
	data: () => ({
		detail: false,
		selected: undefined,
		hotspots: [
			{
				id: 'shoulder',
				copy: '<strong>SHOULDER</strong> - The forensic pathologist will examine the skin for any abrasions, cuts bruises, distinguishing marks or tattoos on the body.',
			},
			{
				id: 'leg',
				copy: '<strong>LEG</strong> - The forensic pathologist will look for any lividity (blood pooling) to help determine the time since death. Lividity can tell the pathologist a lot about the position of the body after death.',
			},
			{
				id: 'chest',
				copy: '<strong>Chest</strong> - The forensic pathologist will pay particular attention to the external examination in suspicious deaths - looking at the clothes or paying attention to any unusual smells or odours.',
			},
			{
				id: 'elbow',
				copy: '<strong>Elbow</strong> - The forensic pathologist will test for rigor mortis by bending the elbow and knees or opening the jaw to see if they move or not.',
			},
			{
				id: 'fingers',
				copy: '<strong>FINGERS</strong> - The forensic pathologist will look under the fingernails as valuable forensic information can be trapped there.',
			},
			{
				id: 'table',
				copy: '<strong>Autopsy table</strong> - The autopsy table is a waist-high or height adjustable stainless steel table with running water to facilitate washing away all the blood that is released during the procedure. The autopsy table is a slanted tray (for drainage) with raised edges (to keep blood and fluids from flowing onto the floor).',
			},
		],
	}),
	methods: {
		showHotspot(hotspot: string) {
			if (this.selected === hotspot) {
				this.selected = undefined;
			} else {
				this.selected = hotspot;
			}
		},
	},
})
;
